import { useCallback, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { has, mapKeys } from "lodash";

const useHiddenFields = () => {
    const [hiddenFieldValues, setHiddenFieldValues] = useState({});

    const {
        wp: { formsOptionsPage },
    } = useStaticQuery(graphql`
        query UseHiddenFieldsQuery {
            wp {
                formsOptionsPage {
                    hiddenFields {
                        pageTitle
                        pageUrl
                        productSku
                        productUrl
                        subcategory
                        websiteFormDate
                    }
                }
            }
        }
    `);

    const setHiddenFields = useCallback(
        (fieldsToSet) => {
            const fieldKeys = formsOptionsPage?.hiddenFields || {};

            const formattedHiddenFields = mapKeys(fieldsToSet, (value, key) =>
                has(fieldKeys, key) && fieldKeys[key] ? fieldKeys[key] : key,
            );

            if (
                has(fieldKeys, "websiteFormDate") &&
                fieldKeys["websiteFormDate"]
            ) {
                formattedHiddenFields[fieldKeys["websiteFormDate"]] =
                    Math.floor(Date.now() / 1000);
            }

            setHiddenFieldValues(formattedHiddenFields);
        },
        [formsOptionsPage?.hiddenFields],
    );

    return { hiddenFieldValues, setHiddenFields };
};

export default useHiddenFields;
